import React from 'react';
import { toast } from 'react-toastify';

import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery } from 'redux-saga/effects';

import { NotificationCard, NotificationVariant } from '../../components/notifications/NotificationCard';
import i18n from '../../i18n';
import { TOAST_AUTO_CLOSE_DURATION } from '../../theme';
import { ToastPayload, toastReducer } from '../reducers/toast.reducer';

const { showToast, setToast } = toastReducer.actions;

// Map toast types to NotificationCard variants
const mapTypeToVariant = (type: string): NotificationVariant => {
  switch (type) {
    case 'success':
      return 'success';
    case 'error':
      return 'failure';
    case 'warning':
      return 'warning';
    default:
      return 'warning'; // Default to warning for 'info' type
  }
};

function* showToastAction(action: PayloadAction<ToastPayload>) {
  const { message, type } = action.payload;
  const translatedMessage = i18n.t(message);

  yield put(setToast({ ...action.payload, message: translatedMessage }));

  const variant = mapTypeToVariant(type);

  yield call(
    toast,
    ({ closeToast }) =>
      React.createElement(NotificationCard, {
        variant,
        title: translatedMessage,
        onClose: closeToast,
        autoHideDuration: TOAST_AUTO_CLOSE_DURATION, // Sync with react-toastify autoClose
      }),
    {
      autoClose: TOAST_AUTO_CLOSE_DURATION,
      closeButton: false,
      style: {
        background: 'transparent',
        boxShadow: 'none',
        padding: 0,
      },
    },
  );
}

export default function* toastSaga() {
  yield takeEvery(showToast, showToastAction);
}
